import * as React from 'react';
import {SVGProps} from 'react';
const Note = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="0.75em"
    viewBox="0 0 18 17"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0.727295 0.917894C3.87899 0.917894 8.19344 0.7592 11.2916 0.842326C15.4454 0.948122 17.0136 2.7391 17.0671 7.1523C17.1207 9.65363 17.0671 16.8024 17.0671 16.8024H12.5691C12.5691 10.5453 12.592 9.51005 12.5691 7.5377C12.5155 5.79963 12.0183 4.97593 10.6643 4.81723C9.2338 4.65854 5.22534 4.79456 5.22534 4.79456V16.81H0.727295V0.917894Z" />
  </svg>
);
export default Note;
